import { createClient } from '@supabase/supabase-js'

// Secure environment variables with fallback
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://nppdewhcixhbdckjcxam.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5wcGRld2hjaXhoYmRja2pjeGFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgxMjMxMzgsImV4cCI6MjA3MzY5OTEzOH0.qR3TxWuHusGQBSC_Dw_BCeCYthK0mLVplFR-irL8iSk'

export const supabase = createClient(supabaseUrl, supabaseKey)